import styled from "styled-components";

export const CardTitleContainer = styled.div`
  height: 60px;
  border-radius: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
`;

export const ContainerSalir = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
`;
